import Swiper, { Navigation, Scrollbar } from 'swiper';

const products_slider = document.querySelectorAll(
  '.section__products__grid .swiper'
);

products_slider.forEach((slider) => {
  new Swiper(slider, {
    slidesPerView: 'auto',
    modules: [Navigation, Scrollbar],
    spaceBetween: 15,
    navigation: {
      prevEl: slider.querySelector('.prev'),
      nextEl: slider.querySelector('.next'),
    },
    scrollbar: {
      el: slider.querySelector('.scrollbar'),
      hide: false,
    },
  });
});
